/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    code: "code",
    ul: "ul",
    li: "li",
    a: "a",
    pre: "pre",
    span: "span"
  }, _provideComponents(), props.components);
  return React.createElement(React.Fragment, null, React.createElement(_components.p, null, "以下の条件を満たす", React.createElement(_components.code, null, "Item<V>"), "型を受け入れるGeneric Typeを持つクラスを定義するつもりで、以下のクラス ", React.createElement(_components.code, null, "Generator"), " を定義しました。"), "\n", React.createElement(_components.ul, null, "\n", React.createElement(_components.li, null, React.createElement(_components.code, null, "Generator"), " クラスは ", React.createElement(_components.code, null, "Item<unknown>"), " 型を受け入れるGeneric Typeを持つ（", React.createElement(_components.a, {
    href: "https://www.typescriptlang.org/docs/handbook/2/generics.html#generic-constraints"
  }, "Generic constraints"), "）"), "\n", React.createElement(_components.li, null, React.createElement(_components.code, null, "Item<V>"), " の Generic Type（", React.createElement(_components.code, null, "V"), "）の型は制限しないこと(= ", React.createElement(_components.code, null, "unknown"), " type)としたい"), "\n", React.createElement(_components.li, null, "コンストラクタで受け取る", React.createElement(_components.code, null, "T"), "型 (= ", React.createElement(_components.code, null, "extends Item<unknown>"), ") と ", React.createElement(_components.code, null, "Processor<T>"), " 型において、同一の", React.createElement(_components.code, null, "T"), "であるという制約を設けたい"), "\n"), "\n", React.createElement(_components.pre, {
    className: "language-typescript"
  }, React.createElement(_components.code, {
    className: "language-typescript"
  }, React.createElement(_components.span, {
    className: "token keyword"
  }, "interface"), " ", React.createElement(_components.span, {
    className: "token class-name"
  }, React.createElement(_components.span, {
    className: "token maybe-class-name"
  }, "Item"), React.createElement(_components.span, {
    className: "token operator"
  }, "<"), React.createElement(_components.span, {
    className: "token constant"
  }, "V"), React.createElement(_components.span, {
    className: "token operator"
  }, ">")), " ", React.createElement(_components.span, {
    className: "token punctuation"
  }, "{"), "\n  value", React.createElement(_components.span, {
    className: "token operator"
  }, ":"), " ", React.createElement(_components.span, {
    className: "token constant"
  }, "V"), "\n  ", React.createElement(_components.span, {
    className: "token function-variable function"
  }, "clone"), React.createElement(_components.span, {
    className: "token operator"
  }, ":"), " ", React.createElement(_components.span, {
    className: "token punctuation"
  }, "("), React.createElement(_components.span, {
    className: "token punctuation"
  }, ")"), " ", React.createElement(_components.span, {
    className: "token arrow operator"
  }, "=>"), " ", React.createElement(_components.span, {
    className: "token maybe-class-name"
  }, "Item"), React.createElement(_components.span, {
    className: "token operator"
  }, "<"), React.createElement(_components.span, {
    className: "token constant"
  }, "V"), React.createElement(_components.span, {
    className: "token operator"
  }, ">"), "\n", React.createElement(_components.span, {
    className: "token punctuation"
  }, "}"), "\n\n", React.createElement(_components.span, {
    className: "token keyword"
  }, "class"), " ", React.createElement(_components.span, {
    className: "token class-name"
  }, React.createElement(_components.span, {
    className: "token maybe-class-name"
  }, "Processor"), React.createElement(_components.span, {
    className: "token operator"
  }, "<"), React.createElement(_components.span, {
    className: "token constant"
  }, "U"), " ", React.createElement(_components.span, {
    className: "token keyword"
  }, "extends"), " ", React.createElement(_components.span, {
    className: "token maybe-class-name"
  }, "Item"), React.createElement(_components.span, {
    className: "token operator"
  }, "<"), React.createElement(_components.span, {
    className: "token builtin"
  }, "unknown"), React.createElement(_components.span, {
    className: "token operator"
  }, ">>")), " ", React.createElement(_components.span, {
    className: "token punctuation"
  }, "{"), "\n  ", React.createElement(_components.span, {
    className: "token function"
  }, "setObject"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "("), "obj", React.createElement(_components.span, {
    className: "token operator"
  }, ":"), " ", React.createElement(_components.span, {
    className: "token constant"
  }, "U"), React.createElement(_components.span, {
    className: "token punctuation"
  }, ")"), " ", React.createElement(_components.span, {
    className: "token punctuation"
  }, "{"), " ", React.createElement(_components.span, {
    className: "token punctuation"
  }, "}"), "\n", React.createElement(_components.span, {
    className: "token punctuation"
  }, "}"), "\n\n", React.createElement(_components.span, {
    className: "token keyword"
  }, "class"), " ", React.createElement(_components.span, {
    className: "token class-name"
  }, React.createElement(_components.span, {
    className: "token maybe-class-name"
  }, "Generator"), React.createElement(_components.span, {
    className: "token operator"
  }, "<"), React.createElement(_components.span, {
    className: "token constant"
  }, "T"), " ", React.createElement(_components.span, {
    className: "token keyword"
  }, "extends"), " ", React.createElement(_components.span, {
    className: "token maybe-class-name"
  }, "Item"), React.createElement(_components.span, {
    className: "token operator"
  }, "<"), React.createElement(_components.span, {
    className: "token builtin"
  }, "unknown"), React.createElement(_components.span, {
    className: "token operator"
  }, ">>")), " ", React.createElement(_components.span, {
    className: "token punctuation"
  }, "{"), "\n  ", React.createElement(_components.span, {
    className: "token function"
  }, "constructor"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "("), React.createElement(_components.span, {
    className: "token keyword"
  }, "private"), " obj", React.createElement(_components.span, {
    className: "token operator"
  }, ":"), " ", React.createElement(_components.span, {
    className: "token constant"
  }, "T"), React.createElement(_components.span, {
    className: "token punctuation"
  }, ","), " ", React.createElement(_components.span, {
    className: "token keyword"
  }, "private"), " processor", React.createElement(_components.span, {
    className: "token operator"
  }, ":"), " ", React.createElement(_components.span, {
    className: "token maybe-class-name"
  }, "Processor"), React.createElement(_components.span, {
    className: "token operator"
  }, "<"), React.createElement(_components.span, {
    className: "token constant"
  }, "T"), React.createElement(_components.span, {
    className: "token operator"
  }, ">"), React.createElement(_components.span, {
    className: "token punctuation"
  }, ")"), " ", React.createElement(_components.span, {
    className: "token punctuation"
  }, "{"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "}"), "\n\n  ", React.createElement(_components.span, {
    className: "token function"
  }, "process"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "("), React.createElement(_components.span, {
    className: "token punctuation"
  }, ")"), " ", React.createElement(_components.span, {
    className: "token punctuation"
  }, "{"), "\n    ", React.createElement(_components.span, {
    className: "token keyword"
  }, "const"), " cloned ", React.createElement(_components.span, {
    className: "token operator"
  }, "="), " ", React.createElement(_components.span, {
    className: "token keyword"
  }, "this"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "."), React.createElement(_components.span, {
    className: "token property-access"
  }, "obj"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "."), React.createElement(_components.span, {
    className: "token method function property-access"
  }, "clone"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "("), React.createElement(_components.span, {
    className: "token punctuation"
  }, ")"), "\n    ", React.createElement(_components.span, {
    className: "token keyword"
  }, "this"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "."), React.createElement(_components.span, {
    className: "token property-access"
  }, "processor"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "."), React.createElement(_components.span, {
    className: "token method function property-access"
  }, "setObject"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "("), "cloned", React.createElement(_components.span, {
    className: "token punctuation"
  }, ")"), "\n  ", React.createElement(_components.span, {
    className: "token punctuation"
  }, "}"), "\n", React.createElement(_components.span, {
    className: "token punctuation"
  }, "}"), "\n")), "\n", React.createElement(_components.p, null, "しかし、上記のような定義では、", React.createElement(_components.code, null, "process()"), " の", React.createElement(_components.code, null, "this.processor.setObject(cloned)"), "においてType Errorとなります。"), "\n", React.createElement(_components.ul, null, "\n", React.createElement(_components.li, null, React.createElement(_components.code, null, "cloned"), " の型は ", React.createElement(_components.code, null, "Item<unknown>"), " と評価されている状態（", React.createElement(_components.code, null, "this.obj"), " は ", React.createElement(_components.code, null, "Item<unknown>"), " として評価されるため、", React.createElement(_components.code, null, "Item<unknown> = {value: unknown, clone: () => Item<unknown>"), " と評価される）", "\n", React.createElement(_components.ul, null, "\n", React.createElement(_components.li, null, "（わたしはここ ", React.createElement(_components.code, null, "cloned"), " の型は ", React.createElement(_components.code, null, "T"), " と評価されるべきと勘違いしてしまっていたのだった）"), "\n"), "\n"), "\n", React.createElement(_components.li, null, "一方で ", React.createElement(_components.code, null, "this.processor.setObject"), " の第一引数は ", React.createElement(_components.code, null, "T"), " 型を要求している"), "\n"), "\n", React.createElement(_components.p, null, React.createElement(_components.code, null, "T"), "型よりも", React.createElement(_components.code, null, "Item<unknown>"), "のほうが取りうる型の範囲が広いので、以下のType Errorが表示されます。"), "\n", React.createElement(_components.pre, {
    className: "language-text"
  }, React.createElement(_components.code, {
    className: "language-text"
  }, "Argument of type 'Item<unknown>' is not assignable to parameter of type 'T'.\n  'Item<unknown>' is assignable to the constraint of type 'T', but 'T' could be instantiated with a different subtype of constraint 'Item<unknown>'.\n")), "\n", React.createElement(_components.p, null, "よく考えてみれば、制約をしたいのは ", React.createElement(_components.code, null, "Item<V>"), " そのものではなく、", React.createElement(_components.code, null, "V"), " なので、以下のように修正してみます。"), "\n", React.createElement(_components.pre, {
    className: "language-typescript"
  }, React.createElement(_components.code, {
    className: "language-typescript"
  }, React.createElement(_components.span, {
    className: "token keyword"
  }, "class"), " ", React.createElement(_components.span, {
    className: "token class-name"
  }, React.createElement(_components.span, {
    className: "token maybe-class-name"
  }, "Generator"), React.createElement(_components.span, {
    className: "token operator"
  }, "<"), React.createElement(_components.span, {
    className: "token constant"
  }, "T"), React.createElement(_components.span, {
    className: "token operator"
  }, ">")), " ", React.createElement(_components.span, {
    className: "token punctuation"
  }, "{"), "\n  ", React.createElement(_components.span, {
    className: "token function"
  }, "constructor"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "("), React.createElement(_components.span, {
    className: "token keyword"
  }, "private"), " obj", React.createElement(_components.span, {
    className: "token operator"
  }, ":"), " ", React.createElement(_components.span, {
    className: "token maybe-class-name"
  }, "Item"), React.createElement(_components.span, {
    className: "token operator"
  }, "<"), React.createElement(_components.span, {
    className: "token constant"
  }, "T"), React.createElement(_components.span, {
    className: "token operator"
  }, ">"), React.createElement(_components.span, {
    className: "token punctuation"
  }, ","), " ", React.createElement(_components.span, {
    className: "token keyword"
  }, "private"), " processor", React.createElement(_components.span, {
    className: "token operator"
  }, ":"), " ", React.createElement(_components.span, {
    className: "token maybe-class-name"
  }, "Processor"), React.createElement(_components.span, {
    className: "token operator"
  }, "<"), React.createElement(_components.span, {
    className: "token maybe-class-name"
  }, "Item"), React.createElement(_components.span, {
    className: "token operator"
  }, "<"), React.createElement(_components.span, {
    className: "token constant"
  }, "T"), React.createElement(_components.span, {
    className: "token operator"
  }, ">>"), React.createElement(_components.span, {
    className: "token punctuation"
  }, ")"), " ", React.createElement(_components.span, {
    className: "token punctuation"
  }, "{"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "}"), "\n\n  ", React.createElement(_components.span, {
    className: "token function"
  }, "process"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "("), React.createElement(_components.span, {
    className: "token punctuation"
  }, ")"), " ", React.createElement(_components.span, {
    className: "token punctuation"
  }, "{"), "\n    ", React.createElement(_components.span, {
    className: "token keyword"
  }, "const"), " cloned ", React.createElement(_components.span, {
    className: "token operator"
  }, "="), " ", React.createElement(_components.span, {
    className: "token keyword"
  }, "this"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "."), React.createElement(_components.span, {
    className: "token property-access"
  }, "obj"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "."), React.createElement(_components.span, {
    className: "token method function property-access"
  }, "clone"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "("), React.createElement(_components.span, {
    className: "token punctuation"
  }, ")"), "\n    ", React.createElement(_components.span, {
    className: "token keyword"
  }, "this"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "."), React.createElement(_components.span, {
    className: "token property-access"
  }, "processor"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "."), React.createElement(_components.span, {
    className: "token method function property-access"
  }, "setObject"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "("), "cloned", React.createElement(_components.span, {
    className: "token punctuation"
  }, ")"), "\n  ", React.createElement(_components.span, {
    className: "token punctuation"
  }, "}"), "\n", React.createElement(_components.span, {
    className: "token punctuation"
  }, "}"), "\n")), "\n", React.createElement(_components.p, null, "以下のようなItemを実装したクラスを定義したとき"), "\n", React.createElement(_components.pre, {
    className: "language-typescript"
  }, React.createElement(_components.code, {
    className: "language-typescript"
  }, React.createElement(_components.span, {
    className: "token keyword"
  }, "class"), " ", React.createElement(_components.span, {
    className: "token class-name"
  }, React.createElement(_components.span, {
    className: "token maybe-class-name"
  }, "NumberItem")), " ", React.createElement(_components.span, {
    className: "token keyword"
  }, "implements"), " ", React.createElement(_components.span, {
    className: "token class-name"
  }, React.createElement(_components.span, {
    className: "token maybe-class-name"
  }, "Item"), React.createElement(_components.span, {
    className: "token operator"
  }, "<"), React.createElement(_components.span, {
    className: "token builtin"
  }, "number"), React.createElement(_components.span, {
    className: "token operator"
  }, ">")), " ", React.createElement(_components.span, {
    className: "token punctuation"
  }, "{"), "\n  ", React.createElement(_components.span, {
    className: "token function"
  }, "constructor"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "("), React.createElement(_components.span, {
    className: "token keyword"
  }, "private"), " _value", React.createElement(_components.span, {
    className: "token operator"
  }, ":"), " ", React.createElement(_components.span, {
    className: "token builtin"
  }, "number"), React.createElement(_components.span, {
    className: "token punctuation"
  }, ")"), " ", React.createElement(_components.span, {
    className: "token punctuation"
  }, "{"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "}"), "\n\n  ", React.createElement(_components.span, {
    className: "token keyword"
  }, "get"), " ", React.createElement(_components.span, {
    className: "token function"
  }, "value"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "("), React.createElement(_components.span, {
    className: "token punctuation"
  }, ")"), " ", React.createElement(_components.span, {
    className: "token punctuation"
  }, "{"), " ", React.createElement(_components.span, {
    className: "token keyword control-flow"
  }, "return"), " ", React.createElement(_components.span, {
    className: "token keyword"
  }, "this"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "."), React.createElement(_components.span, {
    className: "token property-access"
  }, "_value"), " ", React.createElement(_components.span, {
    className: "token punctuation"
  }, "}"), "\n  ", React.createElement(_components.span, {
    className: "token function"
  }, "clone"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "("), React.createElement(_components.span, {
    className: "token punctuation"
  }, ")"), " ", React.createElement(_components.span, {
    className: "token punctuation"
  }, "{"), " ", React.createElement(_components.span, {
    className: "token keyword control-flow"
  }, "return"), " ", React.createElement(_components.span, {
    className: "token keyword"
  }, "new"), " ", React.createElement(_components.span, {
    className: "token class-name"
  }, React.createElement(_components.span, {
    className: "token maybe-class-name"
  }, "NumberItem")), React.createElement(_components.span, {
    className: "token punctuation"
  }, "("), React.createElement(_components.span, {
    className: "token keyword"
  }, "this"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "."), React.createElement(_components.span, {
    className: "token property-access"
  }, "_value"), React.createElement(_components.span, {
    className: "token punctuation"
  }, ")"), " ", React.createElement(_components.span, {
    className: "token punctuation"
  }, "}"), "\n", React.createElement(_components.span, {
    className: "token punctuation"
  }, "}"), "\n\n", React.createElement(_components.span, {
    className: "token keyword"
  }, "class"), " ", React.createElement(_components.span, {
    className: "token class-name"
  }, React.createElement(_components.span, {
    className: "token maybe-class-name"
  }, "StringItem")), " ", React.createElement(_components.span, {
    className: "token keyword"
  }, "implements"), " ", React.createElement(_components.span, {
    className: "token class-name"
  }, React.createElement(_components.span, {
    className: "token maybe-class-name"
  }, "Item"), React.createElement(_components.span, {
    className: "token operator"
  }, "<"), React.createElement(_components.span, {
    className: "token builtin"
  }, "string"), React.createElement(_components.span, {
    className: "token operator"
  }, ">")), " ", React.createElement(_components.span, {
    className: "token punctuation"
  }, "{"), "\n  ", React.createElement(_components.span, {
    className: "token function"
  }, "constructor"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "("), React.createElement(_components.span, {
    className: "token keyword"
  }, "private"), " _value", React.createElement(_components.span, {
    className: "token operator"
  }, ":"), " ", React.createElement(_components.span, {
    className: "token builtin"
  }, "string"), React.createElement(_components.span, {
    className: "token punctuation"
  }, ")"), " ", React.createElement(_components.span, {
    className: "token punctuation"
  }, "{"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "}"), "\n\n  ", React.createElement(_components.span, {
    className: "token keyword"
  }, "get"), " ", React.createElement(_components.span, {
    className: "token function"
  }, "value"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "("), React.createElement(_components.span, {
    className: "token punctuation"
  }, ")"), " ", React.createElement(_components.span, {
    className: "token punctuation"
  }, "{"), " ", React.createElement(_components.span, {
    className: "token keyword control-flow"
  }, "return"), " ", React.createElement(_components.span, {
    className: "token keyword"
  }, "this"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "."), React.createElement(_components.span, {
    className: "token property-access"
  }, "_value"), " ", React.createElement(_components.span, {
    className: "token punctuation"
  }, "}"), "\n  ", React.createElement(_components.span, {
    className: "token function"
  }, "clone"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "("), React.createElement(_components.span, {
    className: "token punctuation"
  }, ")"), " ", React.createElement(_components.span, {
    className: "token punctuation"
  }, "{"), " ", React.createElement(_components.span, {
    className: "token keyword control-flow"
  }, "return"), " ", React.createElement(_components.span, {
    className: "token keyword"
  }, "new"), " ", React.createElement(_components.span, {
    className: "token class-name"
  }, React.createElement(_components.span, {
    className: "token maybe-class-name"
  }, "StringItem")), React.createElement(_components.span, {
    className: "token punctuation"
  }, "("), React.createElement(_components.span, {
    className: "token keyword"
  }, "this"), React.createElement(_components.span, {
    className: "token punctuation"
  }, "."), React.createElement(_components.span, {
    className: "token property-access"
  }, "_value"), React.createElement(_components.span, {
    className: "token punctuation"
  }, ")"), " ", React.createElement(_components.span, {
    className: "token punctuation"
  }, "}"), "\n", React.createElement(_components.span, {
    className: "token punctuation"
  }, "}"), "\n")), "\n", React.createElement(_components.p, null, "以下のように記述すると、期待通りの評価結果となりました。コンストラクタに渡した引数に対して型推論が行われるので、 ", React.createElement(_components.code, null, "Generator<T>"), " の ", React.createElement(_components.code, null, "T"), " 型を明示的に与えなくても型による制約を得られます。"), "\n", React.createElement(_components.pre, {
    className: "language-typescript"
  }, React.createElement(_components.code, {
    className: "language-typescript"
  }, React.createElement(_components.span, {
    className: "token comment"
  }, "// T型（= NumberItem) が一致するので型チェックはパスする"), "\n", React.createElement(_components.span, {
    className: "token keyword"
  }, "const"), " testB1 ", React.createElement(_components.span, {
    className: "token operator"
  }, "="), " ", React.createElement(_components.span, {
    className: "token keyword"
  }, "new"), " ", React.createElement(_components.span, {
    className: "token class-name"
  }, React.createElement(_components.span, {
    className: "token maybe-class-name"
  }, "GeneratorB")), React.createElement(_components.span, {
    className: "token punctuation"
  }, "("), React.createElement(_components.span, {
    className: "token keyword"
  }, "new"), " ", React.createElement(_components.span, {
    className: "token class-name"
  }, React.createElement(_components.span, {
    className: "token maybe-class-name"
  }, "NumberItem")), React.createElement(_components.span, {
    className: "token punctuation"
  }, "("), React.createElement(_components.span, {
    className: "token number"
  }, "1"), React.createElement(_components.span, {
    className: "token punctuation"
  }, ")"), React.createElement(_components.span, {
    className: "token punctuation"
  }, ","), " ", React.createElement(_components.span, {
    className: "token keyword"
  }, "new"), " ", React.createElement(_components.span, {
    className: "token class-name"
  }, React.createElement(_components.span, {
    className: "token maybe-class-name"
  }, "Processor"), React.createElement(_components.span, {
    className: "token operator"
  }, "<"), React.createElement(_components.span, {
    className: "token maybe-class-name"
  }, "NumberItem"), React.createElement(_components.span, {
    className: "token operator"
  }, ">")), React.createElement(_components.span, {
    className: "token punctuation"
  }, ")"), "\n\n", React.createElement(_components.span, {
    className: "token comment"
  }, "// Type Error (T型が一致しない)"), "\n", React.createElement(_components.span, {
    className: "token keyword"
  }, "const"), " testB2 ", React.createElement(_components.span, {
    className: "token operator"
  }, "="), " ", React.createElement(_components.span, {
    className: "token keyword"
  }, "new"), " ", React.createElement(_components.span, {
    className: "token class-name"
  }, React.createElement(_components.span, {
    className: "token maybe-class-name"
  }, "GeneratorB")), React.createElement(_components.span, {
    className: "token punctuation"
  }, "("), React.createElement(_components.span, {
    className: "token keyword"
  }, "new"), " ", React.createElement(_components.span, {
    className: "token class-name"
  }, React.createElement(_components.span, {
    className: "token maybe-class-name"
  }, "NumberItem")), React.createElement(_components.span, {
    className: "token punctuation"
  }, "("), React.createElement(_components.span, {
    className: "token number"
  }, "1"), React.createElement(_components.span, {
    className: "token punctuation"
  }, ")"), React.createElement(_components.span, {
    className: "token punctuation"
  }, ","), " ", React.createElement(_components.span, {
    className: "token keyword"
  }, "new"), " ", React.createElement(_components.span, {
    className: "token class-name"
  }, React.createElement(_components.span, {
    className: "token maybe-class-name"
  }, "Processor"), React.createElement(_components.span, {
    className: "token operator"
  }, "<"), React.createElement(_components.span, {
    className: "token maybe-class-name"
  }, "StringItem"), React.createElement(_components.span, {
    className: "token operator"
  }, ">")), React.createElement(_components.span, {
    className: "token punctuation"
  }, ")"), "\n")), "\n", React.createElement(_components.p, null, "気が付けば「たしかにそれはそう」となりそうなことですが、なかなか気づけずにはまってしまったのでここにメモを残しておきます。"), "\n", React.createElement(_components.p, null, "ではでは。"));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
